import { Stack, Text } from '@redbubble/design-system';
import { defineMessages, FormattedNumber, useIntl } from '@redbubble/next/intl';
import styles from './VolumeDiscount.module.scss';

interface VolumeDiscountProps {
  thresholds: Array<{ percentOff: number; quantity: number }>;
  originalAmount: number;
  currency: string;
  salePercent: number;
}

const calculateVolumeDiscount = (amount: number, percentOff: number) => {
  const discount = amount * (percentOff / 100);
  return amount - discount;
};

const messages = defineMessages({
  volumeDiscount: {
    defaultMessage: '{discountedAmount} when you buy any {quantity}+',
  },
});

export const VolumeDiscount = ({
  thresholds,
  originalAmount,
  currency,
  salePercent,
}: VolumeDiscountProps) => {
  const intl = useIntl();

  if (!thresholds.length) {
    return null;
  }

  // No guarantee of lowest to highest qty from the data
  const sortedThresholds = thresholds
    .slice()
    .sort((a, b) => a.quantity - b.quantity)
    .filter((discount) => discount.percentOff > salePercent);

  return (
    <Stack>
      {sortedThresholds.map(({ quantity, percentOff }) => {
        const discountedAmount = calculateVolumeDiscount(
          originalAmount,
          percentOff
        );

        return (
          <Text
            className={styles.discountText}
            key={`volumeDiscount-${quantity}-${percentOff}`}
          >
            {intl.formatMessage(messages.volumeDiscount, {
              discountedAmount: (
                <FormattedNumber
                  value={discountedAmount}
                  style="currency"
                  currency={currency}
                />
              ),
              quantity,
            })}
          </Text>
        );
      })}
    </Stack>
  );
};
